import React, {Component, h, Fragment} from "preact";
import {AppPage} from "../_common/components/app-page";
import {connect} from "react-redux";
import {
    fetchAcademicPrograms,
    fetchContractTypes,
    fetchEditingOffer,
    fetchSchedules, saveEditingOffer,
    setEditingOffer, fetchStates, fetchFormativeFamilies
} from "../_rx/jobs/actions";
import { CF, E, FR, R, Card} from "../_common/layout";
import {CompanyCompany, CompanyOffer, CompanyUser} from "../_api";
import {t} from "../_i18n";
import {Field} from 'react-final-form';
import {Form as FinalForm} from 'react-final-form'
import {
    FormField,
    FormFieldRadioCheckbox,
    FormFieldSelect,
    validateString,
    RadioCheckbox,
} from "../_common/forms/components/components";
import {AcademicProgramsSelector} from "./controls/academicProgramSelector";
import {QuestionEditor} from "./controls/questionEditor";
import {
    showErrorClosed,
    validateAcademicProgramInput,
    validateReq,
    validateStringVacancies,
    validateText
} from "./validateOfferEdit";
import {TextAreaFinalForm} from "../_common/forms/components/textArea/textArea";
import {toastService} from "../_services/toast-service";
import {EDIT_OFFER_TITLE, EDIT_OFFER_TITLE_PAGE} from "../constants";
import {Helmet} from "react-helmet";
import AlertBox from "../_common/components/AlertBox/AlertBox";


const modalityFix: any = {
    modality_normal: t('Oferta de trabajo'),
    modality_fct: t('Vacante de prácticas (Formación en Centros de Trabajo)'),
    modality_dual: t('Dual')
}

const modalityOptions = [
    { key: 'normal', name: modalityFix['modality_normal'] },
    { key: 'fct', name: modalityFix['modality_fct'] },
    { key: 'is_remote_process', name: t('Oferta de trabajo (enlace externo)') },
];

const presenceFix: any = {
    presence_on_site: t('Solo presencial'),
    presence_semi: t('Presencial, con posibilidad de teletrabajar'),
    presence_remote: t('Solo teletrabajo')
}

const hardcodedBenefits = [
    "Porcentaje sobre objetivos",
    "Flexibilidad horaria",
    "Teléfono móvil",
    "Seguro médico",
    "Vehículo / kilometraje",
    "Cheque restaurante",
];

const salaryType = [
    {id: 0, name: 'Bruto / año', key: 'Bruto / año'},
    {id: 1, name: 'Bruto / mes', key: 'Bruto / mes'},
    {id: 2, name: 'Bruto / hora', key: 'Bruto / hora'}
];



type Props = {
    company: CompanyCompany,
    loggedUser: CompanyUser,
    editingOffer:CompanyOffer,
    fetchEditingOffer: typeof fetchEditingOffer,
    setEditingOffer: typeof setEditingOffer,
    match: any,
    academic_programs: {[key:string]:string},
    academic_programs_kn: [{keys:string,name:string}],
    schedules_kn: [{keys:string,name:string}],
    contract_types_kn: [{keys:string,name:string}],
    formative_families_kn: [{keys: string, name: string}],
    states_kn: [{keys:string,name:string}],
    fetchAcademicPrograms: typeof fetchAcademicPrograms,
    fetchFormativeFamilies: typeof  fetchFormativeFamilies,
    fetchSchedules: typeof fetchSchedules,
    fetchContractTypes: typeof fetchContractTypes,
    fetchStates: typeof fetchStates,
    saveEditingOffer: typeof saveEditingOffer,
    history: any
}


class View extends Component<Props, any> {
    statusToSend = '';


    state = {
        salaryTypeSelect: 'salary_show_range',
        checkFailed: false
    }



    async componentDidMount() {
        if(this.props.match.params.id) {
            await this.props.fetchEditingOffer({id: this.props.match.params.id});
            let updatedOffer = {...this.props.editingOffer};
            // Convertir expireAt de formato SQL (YYYY-MM-DD HH:MM:SS) a datetime-local (YYYY-MM-DDTHH:MM)
            if(updatedOffer.expireAt) {
                updatedOffer.expireAt = updatedOffer.expireAt.replace(' ', 'T').slice(0, 16);
            }
            if(updatedOffer.isRemoteProcess) {
                updatedOffer.modality = 'is_remote_process';
            }
            if(updatedOffer.expireAt || updatedOffer.isRemoteProcess) {
                this.props.setEditingOffer(updatedOffer);
            }
            if(!this.props.editingOffer.salaryMin && !this.props.editingOffer.salaryMax){
                this.setState({salaryTypeSelect: 'salary_no_show'})
            } else if(this.props.editingOffer.salaryMin && !this.props.editingOffer.salaryMax){
                this.setState({salaryTypeSelect: 'salary_show_min'})
            } else{
                this.setState({salaryTypeSelect: 'salary_show_range'})
            }
        }else
            this.props.setEditingOffer({
                displayCompanyName: true,
                isRemoteProcess: false,
                acceptUnfinished: false,
                academicPrograms:[],
                modality: this.props.loggedUser?.affiliate ? 'is_remote_process' : 'normal',
                benefits:[] as any,
                benefitsText: '',
                text: '',
                requirements: '',
                questions:[],
                presence:'on_site',
                date: new Date().toISOString(),
                expireAt: new Date(new Date().setMonth(new Date().getMonth() + 3)).toISOString().slice(0, 16),
                salaryType:'',
                companyName: '',
                dept: '',
                length: '',
                salaryMin: null as any,
                salaryMax: null as any,

            });

        if(!this.props.academic_programs || !this.props.academic_programs_kn)
            this.props.fetchAcademicPrograms();

        if(!this.props.schedules_kn)
            this.props.fetchSchedules();

        if(!this.props.contract_types_kn)
            this.props.fetchContractTypes();

        if(!this.props.states_kn)
            this.props.fetchStates();

        if(!this.props.formative_families_kn)
            this.props.fetchFormativeFamilies();

    }

    async onSubmit(offer:CompanyOffer){
        if(offer.modality === 'is_remote_process'){
            offer = {...offer, modality: 'normal', isRemoteProcess: true};
        }
        // Convertir expireAt de datetime-local (YYYY-MM-DDTHH:MM) a formato SQL (YYYY-MM-DD HH:MM:SS)
        if(offer.expireAt){
            offer.expireAt = offer.expireAt.replace('T', ' ') + ':00';
        }
        if(!offer.id) offer.status = this.statusToSend;
        const url = this.statusToSend === 'published' ? `/offers${this.props.match.params.id?('/'+this.props.match.params.id+'/applied'):''}` : '/drafts'
        const redirectObject = {history: this.props.history, url: url}
        try {
            await this.props.saveEditingOffer(offer, redirectObject);
        } catch(e: any) {
            if (e.status === 400) toastService.showToast({message: "Beneficios erroneos", type:'danger'});
        }
    }

    forceContractType(args:any, state:any, utils:any){
        if(state.formState.values.modality == 'fct'){
            utils.changeValue(state, 'contractType', ()=>5);
            utils.changeValue(state, 'acceptUnfinished', ()=>true);
        }
        const threeMonthsLater = new Date();
        threeMonthsLater.setMonth(threeMonthsLater.getMonth() + 3);
        utils.changeValue(state, 'expireAt', ()=> threeMonthsLater.toISOString().slice(0, 16));
    }

    forceSalarySelector(state: any, offer: CompanyOffer){
        if(state.salaryTypeSelect === 'salary_show_min'){
            offer.salaryMax = - 1;
        //     utils.changeValue(state, 'salaryMax', ()=>-1);
        }else if (state.salaryTypeSelect === 'salary_no_show'){
            offer.salaryMax = -1;
            offer.salaryMin = -1;
        //     utils.changeValue(state, 'salaryMin', ()=>-1);
        //     utils.changeValue(state, 'salaryMax', ()=>-1);
        }
    }

    componentWillUnmount() {
        this.props.setEditingOffer(null as any);
    }

    scroll(){
        if (!this.state.checkFailed){
            setTimeout(() => {
                const el = document.querySelector('.container');
                el && el.scrollIntoView({ behavior: 'smooth' })
            })
            this.setState({checkFailed: true})
        }

    }

    render({ company, loggedUser, editingOffer, academic_programs, schedules_kn, contract_types_kn, academic_programs_kn, states_kn, formative_families_kn, match, history}:Props) {

        if(!company || !academic_programs || !schedules_kn|| !contract_types_kn || !states_kn || !editingOffer || !formative_families_kn) return null;

        const isAffiliate = !!loggedUser?.affiliate;
        const availableModalityOptions = isAffiliate
            ? modalityOptions.filter(o => o.key === 'is_remote_process')
            : modalityOptions;

        const availableBenefits = [...hardcodedBenefits, ...(editingOffer.benefits as any).filter((b:string)=>!hardcodedBenefits.includes(b))];

        return <FinalForm
                onSubmit={(data:CompanyOffer)=>{this.forceSalarySelector(this.state, data); (this.onSubmit(data)) }} initialValues={editingOffer}
                mutators={{forceContractType:this.forceContractType.bind(this) }}
                render={({handleSubmit,  submitting, values, pristine, submitSucceeded, submitFailed, form:{mutators:{forceContractType}}}:any)=><Fragment>
                    <form className='form' action="" onSubmit={handleSubmit}  noValidate>

                        {submitFailed && this.scroll()}

                        <CF className='max-width-780'>
                        {editingOffer && <Fragment>
                                <Helmet>
                                    <title>{EDIT_OFFER_TITLE_PAGE}</title>
                                </Helmet>

                                <h1>{t(EDIT_OFFER_TITLE)}</h1>

                                <FR>
                                    <E className="col-100">
                                        {isAffiliate
                                            ? <Field name="modality" component="input" type="hidden" />
                                            : <FormFieldSelect label={values.modality === 'is_remote_process' ? t('Tipo de oferta') : t('Modalidad')} name="modality" options={availableModalityOptions} required onChange={forceContractType} noEmptyOption />
                                        }
                                    </E>
                                </FR>

                                {values.modality !== 'is_remote_process' &&
                                <Card className='p-bottom m-bottom'>
                                    <h2>Datos de tu empresa</h2>
                                    {/*<p>{company.name}</p>*/}

                                    <FormFieldRadioCheckbox type="checkbox" name="displayCompanyName" label={'Mostrar identidad de tu empresa'} />

                                    {!values.displayCompanyName && <FormField label={'Nombre alternativo a mostrar'} enabled={values.displayCompanyName} name="companyName" required />}
                                </Card>}


                                <Card className='p-bottom m-bottom'>
                                    <h2 className="p-top">Descripción del puesto</h2>

                                    <FR>
                                        <div className={values.modality === 'is_remote_process' ? "col-100" : "sm-col-80 col-100"}>
                                            <FormField label={'Título de la oferta'} validate={validateString} name="title" required />
                                        </div>
                                        {values.modality !== 'is_remote_process' &&
                                        <div className="sm-col-20 col-100">
                                            <FormField label={'Nº de vacantes'} validate={validateStringVacancies} name="maxJobs"  type="number" min={1} required />
                                        </div>}
                                    </FR>

                                    {/*<Field name='text' validate={text=>(text)?undefined:t('Requerido')} component={EditorText as any} />*/}
                                    {values.modality === 'is_remote_process' &&
                                        <div className="p-top">
                                            <FormField label={t('URL de la oferta')} name="externalUrl" type="url" validate={validateString} required />
                                        </div>
                                    }
                                    <div className="p-top">
                                            <Field name="text"
                                                   validate={values.modality === 'is_remote_process' ? undefined : validateText}
                                                   fnToShow={showErrorClosed}
                                                   title={values.modality === 'is_remote_process' ? t('Descripción del puesto') + ' (' + t('opcional') + ')' : t('Descripción del puesto')}
                                                   subtitle={values.modality === 'is_remote_process' ? undefined : t('Mínimo 100 caracteres')}
                                                   maxlength={values.modality === 'is_remote_process' ? 100 : 4000}
                                                   height={values.modality === 'is_remote_process' ? '100px' : '300px'}
                                                   valueInput={values.text}
                                                   component={TextAreaFinalForm as any}
                                        />
                                        {values.modality !== 'is_remote_process' &&
                                        <FR>
                                            <div className="sm-col-60 col-100">
                                                <FormField  label={'Departamento'} name="dept" />
                                            </div>
                                        </FR>}

                                    </div>
                                    {/*<FormField label={'Departamento (opcional)'} name="dept" />*/}

                                </Card>

                                <Card className='p-bottom m-bottom'>
                                    <h2 className='m-top'>{values.modality === 'is_remote_process' ? t('Localización') : t('Modalidad de trabajo')}</h2>

                                    <FR>
                                        <div className="sm-col-25 col-100"><FormFieldRadioCheckbox type="radio" name="presence" value="on_site" label={presenceFix['presence_on_site']} required /></div>
                                        <div className="sm-col-40 col-100"><FormFieldRadioCheckbox type="radio" name="presence" value="semi" label={presenceFix['presence_semi']} required /></div>
                                        {values.modality !== 'fct' &&
                                          <div className="sm-col-30 col-100"><FormFieldRadioCheckbox type="radio" name="presence" value="remote" label={presenceFix['presence_remote']} required /></div>
                                        }
                                    </FR>

                                    {values.presence !== 'remote' &&
                                        <Card className='background-info'>
                                            <R>
                                                <div className="col-100">
                                                    Indica la ubicación del puesto:
                                                </div>
                                            </R>
                                            <FR>
                                                <E className="sm-col-20 col-100">
                                                    <FormFieldSelect label={'Provincia'} name="state" required options={states_kn} />
                                                </E>
                                                <E className="sm-col-20 col-100">
                                                    <FormField  validate={validateString} label={'Código postal'} name="zip" type="number" min={0} required />
                                                </E>
                                                <E className="sm-col-60 col-100">
                                                    <FormField  validate={validateString} label={'Población'} name="city" required />
                                                </E>
                                            </FR>
                                        </Card>
                                    }

                                    {values.modality != 'fct' && values.modality !== 'is_remote_process' &&
                                        <div className='m-top'>
                                            <h2 className='m-bottom'>Características del contrato</h2>
                                            <FR>
                                                <E className="sm-col-33 col-100"><FormFieldSelect name="contractType" label={t('Tipo de contrato')} required options={contract_types_kn}/></E>
                                                <E className="sm-col-33 col-100"><FormFieldSelect name="schedule" label={t('Jornada laboral')} required options={schedules_kn}/></E>
                                                <E className="sm-col-33 col-100"><FormField name="length" label={'Duración'}/></E>
                                            </FR>
                                        </div>
                                    }

                                    {values.modality != 'fct' &&
                                    <div className='m-top'>
                                        <h2>{values.modality === 'is_remote_process' ? t('Salario') + ' (' + t('opcional') + ')' : t('Salario')}</h2>
                                        <p>Indica qué quieres mostrar:</p>
                                        <FR className="sm-row-3-el row-1-el">
                                            <E><RadioCheckbox type="radio" name="salaryTypeSelect" value="salary_show_range" label={'Mostrar rango'} checked={this.state.salaryTypeSelect === 'salary_show_range'} onChange={() => {this.setState({salaryTypeSelect: 'salary_show_range'}); /* forceSalarySelector('salary_show_range')*/}}/></E>
                                            <E><RadioCheckbox type="radio" name="salaryTypeSelect" value="salary_show_min" label={'Mostrar salario mínimo'} checked={this.state.salaryTypeSelect === 'salary_show_min'} onChange={() => {this.setState({salaryTypeSelect: 'salary_show_min'}); /* forceSalarySelector('salary_show_min')*/}}/></E>
                                            <E><RadioCheckbox type="radio" name="salaryTypeSelect" value="salary_no_show" label={'Salario no disponible'} checked={this.state.salaryTypeSelect === 'salary_no_show'}  onChange={() => {this.setState({salaryTypeSelect: 'salary_no_show'}); /* forceSalarySelector('salary_no_show')*/}}/></E>
                                        </FR>
                                        {(this.state.salaryTypeSelect !== 'salary_no_show') &&
                                        <Card className='background-info'>
                                            <FR className="sm-row-3-el row-1-el">
                                                <E><FormFieldSelect label={t('Tipo de salario')} name="salaryType" options={salaryType} required/></E>
                                                <E className="input-symbol-euro input-symbol-euro-right">
                                                    <FormField required validate={validateString} label={'Mínimo'} name="salaryMin" type="number" min={0}/>
                                                    <i>€</i>
                                                </E>
                                                {(this.state.salaryTypeSelect !== 'salary_show_min') && <E className="input-symbol-euro input-symbol-euro-right">
                                                    <FormField required validate={validateString} label={'Máximo'} name="salaryMax" type="number" min={0}/>
                                                    <i>€</i>
                                                </E>}
                                            </FR>
                                        </Card>
                                        }
                                    </div>}
                                    {values.modality != 'fct' && values.modality !== 'is_remote_process' &&
                                        <div className='m-top'>
                                            <h2>{t('Beneficios laborales')} ({t('opcional')})</h2>
                                            <FR className="sm-row-3-el row-2-el">
                                                {availableBenefits.map(b => <E><FormFieldRadioCheckbox type="checkbox" name="benefits" value={b} label={b}/></E>)}
                                            </FR>
                                            <FormField label={'Otros (separados por coma)'} type="text" name="benefitsText" />
                                        </div>
                                    }
                                </Card>

                                <Card className='m-bottom p-bottom'>
                                    <h2 className='m-bottom'>{values.modality === 'is_remote_process' ? t('Formación solicitada') : t('Requisitos del candidato')}</h2>
                                    <div className='m-top'>
                                        {values.modality !== 'is_remote_process' && <h3>Ciclos solicitados</h3>}
                                        <p>{values.modality === 'is_remote_process'
                                            ? t('Sólo se recibirán candidatos que cursen o hayan cursado los ciclos que indiques.')
                                            : t('Solo se podrán inscribir los candidatos que cursen o hayan cursado los ciclos que indiques.')}</p>

                                        <Field name="academicPrograms"
                                               academic_programs={academic_programs}
                                               academic_programs_kn={academic_programs_kn}
                                               formative_families_kn={formative_families_kn}
                                               validate={validateAcademicProgramInput}
                                               component={AcademicProgramsSelector as any} />

                                    </div>

                                    {values.modality != 'fct' && values.modality !== 'is_remote_process' &&
                                    <FormFieldRadioCheckbox className='m-bottom' type="checkbox" name="acceptUnfinished" label="Aceptar ciclo no finalizado" />}

                                    {/*<Field name='requirements' validate={v=>v?undefined:t('Requerido')} component={EditorText as any} />*/}
                                    {values.modality !== 'is_remote_process' &&
                                    <div className="p-top">

                                        <Field name="requirements"
                                               validate={validateReq}
                                               fnToShow={showErrorClosed}
                                               title={t('Requisitos mínimos')}
                                               maxlength={4000}
                                               height='300px'
                                               valueInput={values.requirements}
                                               component={TextAreaFinalForm as any}
                                        />
                                    </div>}
                                </Card>

                                {values.modality !== 'is_remote_process' &&
                                <Card className='m-bottom'>
                                    <h2 className='m-top m-x2-bottom'>{t('Cuestionario de inscripción')} ({t('opcional')})</h2>
                                    {editingOffer.hasApplications && <AlertBox type='warning' className='m-bottom-half'><span>{t('Las preguntas del cuestionario no se pueden editar porque ya hay candidatos inscritos en la oferta.')}</span></AlertBox>}
                                    <Field name="questions" component={QuestionEditor as any} disabled={editingOffer.hasApplications}/>
                                </Card>}

                                <Card>
                                    <FormFieldRadioCheckbox type="checkbox" name="isRemoteProcess" label="Proceso de selección online." />
                                    <p>Marca esta opción si vas a seleccionar personal a distancia, por internet o teléfono. De esta forma los candidatos sabrán que no tienen que desplazarse o hacer entrevistas de forma presencial.</p>
                                </Card>

                                <Card className='p-bottom m-bottom'>
                                    <h2 className='m-top'>{values.modality === 'is_remote_process' ? t('Límite publicación') : t('Fecha límite')}</h2>
                                    <p>{values.modality === 'is_remote_process'
                                        ? t('La oferta dejará de estar activa después del periodo indicado.')
                                        : t('Establece una fecha límite para la oferta. Pasada esta fecha, la oferta dejará de estar publicada.')}</p>
                                    <FR>
                                        <E className="sm-col-50 col-100">
                                            <FormField label={values.modality === 'is_remote_process' ? t('Límite publicación') : t('Fecha límite')} name="expireAt" type="datetime-local" validate={validateString} required />
                                        </E>
                                    </FR>
                                </Card>


                        </Fragment>}

                            <FR>
                                {(!values.id) &&
                                <E>
                                    <button className={'btn btn-ghost submit sm-auto-width'} type='submit' disabled={submitting} onClick={()=>{this.statusToSend =  'unpublished'}}>Guardar Borrador</button>
                                </E>}
                                <E>
                                    <button className={'btn btn-primary submit sm-auto-width'} type='submit' disabled={submitting} onClick={()=>{this.statusToSend = 'published'}}>{values.id?'Guardar':'Publicar'}</button>
                                    <button className={'btn btn-link sm-auto-width'} type='button' disabled={submitting} onClick={()=>{history.push('/offers')}}>Cancelar</button>
                                </E>
                            </FR>
                        </CF>

                    </form>
                </Fragment>}/>
        }

}


const ConnectedView: any = connect(
    ({offerReducer:{editingOffer}, fixtures:{states_kn, contract_types_kn, schedules_kn, academic_programs, academic_programs_kn, formative_families_kn}, company, auth:{loggedUser}}:any)=>({editingOffer, academic_programs, academic_programs_kn, contract_types_kn, schedules_kn, states_kn, formative_families_kn, company, loggedUser}),
    {fetchEditingOffer, fetchAcademicPrograms, fetchSchedules, fetchContractTypes, setEditingOffer, saveEditingOffer, fetchStates, fetchFormativeFamilies})(View as any);

export default ({archived=false, ...rest}) =>
    <AppPage
        name="offer-edit"
        subtitle=""
        className="max-width-980">
        <ConnectedView {...rest} />

    </AppPage>
;
